/* eslint-disable @typescript-eslint/no-explicit-any */
import { all, AllEffect } from 'redux-saga/effects'

import { fetchClientDataSaga } from './clientData'
import { configurationSaga } from './configuration'
import { loginSaga } from './login'
import { sendToLoginFallbackSaga, sendToSaga } from './sendTo'

export default function* rootSaga(): Generator<AllEffect<any>, void, unknown> {
  yield all([configurationSaga(), loginSaga(), fetchClientDataSaga(), sendToSaga(), sendToLoginFallbackSaga()])
}
